<template>
  <v-layout row wrap class="add-parts" v-cloak>
    <v-flex class="flex-column add-parts__col add-parts__col--left">
      <v-card class="fill-height flex-column scroll-card" color="lightbg">
        <div class="quote-builder__card-inner inner-scroll">
          <v-card-title class="pt-0">
            <h3
              class="subheading font-weight-bold secondary--text"
            >STEP 2: Choose Type of {{ categoryObject.name }}</h3>
          </v-card-title>

          <v-card-text class="py-0 inner-scroll__scroller">
            <decision-tree
              :category="category"
              @filter-products="filterProducts"
              @reset-products="resetProducts"
              ref="decision_tree"
            ></decision-tree>
          </v-card-text>

          <v-divider class="mx-3 my-4"></v-divider>

          <v-card-text class="py-0">
            <v-text-field
              v-model="searchText"
              outline
              single-line
              flat
              hide-details
              :loading="loadingProducts"
              label="Search by Part Number or Name"
              @keyup.enter="search"
            >
              <fa-icon
                slot="append"
                :icon="['far', 'search']"
                fixed-width
                @click="search"
                style="cursor: pointer"
              />
            </v-text-field>
          </v-card-text>
        </div>
      </v-card>

      <v-card-actions class="pb-0 px-0">
        <v-btn flat exact :to="getBuilderUrl(currentDocument, 1)">
          <div class="v-icon v-icon--left">
            <fa-icon :icon="['far', 'chevron-left']" transform="shrink-4" size="xs" />
          </div>Back
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click="clearAttributes()" :disabled="!hasOptions">Clear All</v-btn>
      </v-card-actions>
    </v-flex>

    <v-flex class="add-parts__col add-parts__col--right">
      <div class="product-display">
        <v-card-title>
          <h3 class="subheading font-weight-bold secondary--text">Results</h3>

          <v-spacer></v-spacer>

          <span
            v-if="results.length > 0"
            class="caption font-weight-bold"
          >Total Results Found: {{ results.length }}</span>

          <!-- <v-pagination
						class="product-display__pagination"
						v-model="pagination_page"
						total-visible="0"
						:length="pagination.length"
          ></v-pagination>-->
        </v-card-title>

        <transition-group
          name="cards"
          class="product-display__products"
          tag="div"
          ref="display"
          appear
          v-show="results.length > 0"
        >
          <product-card
            v-for="product in chunkedResults"
            :key="product.id"
            :product="product"
            @select-product="selectProduct"
          ></product-card>
        </transition-group>

        <transition name="fade" v-if="results.length === 0">
          <div class="product-display__browse">
            <button class="product-display__all-btn" @click="allProducts">
              <div
                v-if="searchText.length > 0 && searched"
                class="subheading text-uppercase"
              >No results found for "{{ searchText }}".</div>

              <div
                class="subheading text-uppercase"
                v-text="Object.keys(options).length ? 'No Results Found' : 'Not Sure?'"
              ></div>
              <div class="headline">Click here to browse all {{ categoryObject['plural'] }}</div>
              <div
                class="headline"
                v-if="categoryObject.additional_not_sure_verbiage"
              >{{ categoryObject.additional_not_sure_verbiage }}</div>
            </button>
          </div>
        </transition>

        <transition name="fade" v-if="loadingProducts">
          <div class="product-display__loader">
            <div class="spinner">
              <div class="circle circle--1"></div>
              <div class="circle circle--2"></div>
            </div>
          </div>
        </transition>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import DecisionTree from "@components/partials/DecisionTree";
import ProductCard from "@components/partials/ProductCard";

var { mainRoutes } = require("@root/mixins");

export default {
  mixins: [mainRoutes],

  data() {
    return {
      searched: false,
      atBottom: false,
      loadingProducts: false,
      searchText: "",
      results: [],
      part_family: null,
      part_type: null,
      pagination_page: 1,
      pagination_length: 0,
      pagination_rowsPerPage: 5,
      options: {}
    };
  },

  components: { DecisionTree, ProductCard },

  props: {
    category: {
      default: null
    }
  },

  computed: {
    ...mapGetters("products", ["categories"]),

    pagination() {
      if (
        this.$vuetify.breakpoint.xs ||
        (this.$vuetify.breakpoint.width > 767 &&
          this.$vuetify.breakpoint.width < 960)
      ) {
        this.pagination_rowsPerPage = 1;
      } else {
        this.pagination_rowsPerPage = 5;
      }

      // console.log(this.pagination_page);
      // if (this.$vuetify.breakpoint.width < 768) {
      // 	this.$nextTick(() => {
      // 		this.$vuetify.goTo(".product-display", {
      // 			duration: 500,
      // 			container: ".v-content__wrap"
      // 		});
      // 	});
      // }

      return {
        page: this.pagination_page,
        length: this.pagination_length,
        rowsPerPage: this.pagination_rowsPerPage
      };
    },

    chunkedResults() {
      let length = Math.ceil(this.results.length / this.pagination.rowsPerPage);

      let page = this.pagination.page;

      if (length < this.pagination.page) {
        page = length;
        this.pagination_page = page;
        // this.$set(this.pagination, "page", page);
      }

      this.pagination_length = length;
      // this.$set(this.pagination, "length", length);

      if (this.results.length > 0) {
        return _.chunk(
          this.results,
          this.pagination.rowsPerPage * (this.pagination.page + 1)
        )[0];
      } else {
        return [];
      }
    },

    categoryObject() {
      return _.find(this.categories, ["slug", this.category]);
    },

    showingResults() {
      let upper = this.pagination.page * this.pagination.rowsPerPage;
      let lower = upper - (this.pagination.rowsPerPage - 1);
      let separator = this.pagination.rowsPerPage > 2 ? "-" : "&";
      let total = this.results.length;

      if (upper > total || upper === lower) {
        return `Showing ${lower} of ${total}`;
      }
      return `Showing ${lower} ${separator} ${upper} of ${total}`;
    },

    hasOptions() {
      return Object.keys(this.options).length > 0 || this.part_type !== null;
    },

    infiniteScrollElement() {
      if (this.$vuetify.breakpoint.width < 1024) {
        return document.getElementsByClassName("v-content__wrap")[0];
      }

      return this.$refs.display.$el;
    }
  },

  methods: {
    ...mapActions("products", {
      GET_ATTRIBUTES: "getAttributes",
      SEARCH_PRODUCTS: "searchProducts"
    }),

    updatePage(value) {
      this.pagination_page = value;
    },

    params(search = false) {
      let params = {};

      if (this.getObjectValue("categoryObject", this)) {
        params.part_family = this.categoryObject.id;
      }

      if (search) {
        if (this.searchText) {
          params.search = this.searchText;
        }
      } else {
        if (this.getObjectValue("part_type", this)) {
          params.type = this.part_type;
        }

        if (this.getObjectValue("options", this)) {
          params.options = this.options;
        }
      }

      return { params };
    },

    filterProducts(selectedAttributes) {
      const part_family = _.find(this.categories, ["slug", this.category]);

      let options = { ...selectedAttributes };

      if (options.hasOwnProperty("type")) {
        this.$set(this, "part_type", options.type);
        delete options.type;
      } else if (this.part_type !== null) {
        this.$set(this, "part_type", null);
      }

      this.$set(this, "part_family", part_family);
      this.$set(this, "options", options);

      this.findProducts();
    },

    search() {
      if (!this.loadingProducts) {
        this.loadingProducts = true;
        this.SEARCH_PRODUCTS(this.params(true)).then(({ data }) => {
          this.searched = true;
          this.results = data;
          this.loadingProducts = false;
        });
      }
    },

    resetProducts() {
      this.$set(this, "options", {});
      this.$set(this, "results", []);
      this.$set(this, "part_type", null);
    },

    findProducts() {
      if (!this.loadingProducts && this.hasOptions) {
        this.loadingProducts = true;
        this.SEARCH_PRODUCTS(this.params()).then(({ data }) => {
          this.results = data;
          this.loadingProducts = false;
        });
      } else {
        this.results = [];
      }
    },

    allProducts() {
      this.clearAttributes();

      if (!this.loadingProducts) {
        this.loadingProducts = true;
        this.SEARCH_PRODUCTS(this.params()).then(({ data }) => {
          this.results = data;
          this.loadingProducts = false;
        });
      }
    },

    clearAttributes() {
      this.$refs.decision_tree.resetAllAttributes();
      this.resetProducts();
    },

    selectProduct(sku) {
      const path = this.getBuilderUrl(this.document, 3, {
        category: this.category,
        sku
      });

      this.$router.push({ path });
    },

    bottomVisible() {
      const scrollY = this.infiniteScrollElement.scrollTop;
      const visible = this.infiniteScrollElement.clientHeight;
      const pageHeight = this.infiniteScrollElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },

    addScrollListener() {
      this.$nextTick(() => {
        this.infiniteScrollElement.addEventListener(
          "scroll",
          this.checkBottom,
          { passive: true }
        );
      });
    },

    checkBottom() {
      this.atBottom = this.bottomVisible();
    }
  },

  watch: {
    atBottom(value) {
      if (value) {
        if (this.pagination_page <= this.pagination_length) {
          this.pagination_page++;
        }
      }
    },

    searchText(value) {
      this.searched = false;
    },

    results(value, oldValue) {
      if (oldValue.length === 0 && value.length > 0) {
        this.addScrollListener();
      } else if (oldValue.length !== value.length) {
        this.pagination_page = 0;
        // this.infiniteScrollElement.removeEventListener("scroll", this.checkBottom, { passive: true });
        this.$nextTick(() => {
          // this.addScrollListener();
          this.infiniteScrollElement.scrollTop = 0;
        });
      }
    }
  }
};
</script>
